export default "__VITE_ASSET__D6d$dYNW__"